import classNames from 'classnames';
import moment, {Moment} from 'moment';
import React from 'react';

import {CalendarInteraction, CalendarItem, LayeredCalendarItems} from 'calendar/CalendarConstants';

import CalendarUtil from './CalendarUtil';
import CalendarWeekHeader from './CalendarWeekHeader';
import WeekComponent from './WeekComponent';

interface Props {
  items: LayeredCalendarItems<CalendarItem>;
  startDate: moment.Moment;
  endDate: moment.Moment;
  monthStart: moment.Moment;
  interact: CalendarInteraction;
  today: moment.Moment;
}

class CalendarMonth extends React.Component<Props> {
  getWeekStarts = (): Array<Moment> => {
    const weeks = [];
    let weekStart = this.props.startDate.clone();
    while (weekStart.isBefore(this.props.endDate)) {
      weeks.push(weekStart);
      weekStart = weekStart.clone().add(1, 'weeks');
    }
    return weeks;
  };

  renderDate = (date: Moment): JSX.Element => {
    const dateInMonth = CalendarUtil.isDateBetween(
      date,
      this.props.monthStart,
      this.props.monthStart.clone().add(1, 'month')
    );
    return (
      <span
        title={date.format('YYYY-MM-DD')}
        className={classNames({'weekComponent-date-text--faded': !dateInMonth})}
      >
        {date.format('D')}
      </span>
    );
  };

  override render(): JSX.Element {
    return (
      <div className="calendarBorderBottom">
        <CalendarWeekHeader />
        {this.getWeekStarts().map((weekStart) => (
          <WeekComponent
            key={weekStart.format()}
            weekStart={weekStart}
            today={this.props.today}
            items={CalendarUtil.calendarItemsInWeek(this.props.items, weekStart)}
            interact={this.props.interact}
            renderDate={this.renderDate}
          />
        ))}
      </div>
    );
  }
}

export default CalendarMonth;
